export default __webpack_public_path__ + "static/media/slide_2.3154c14e.png";